import { request } from "./http";

function canFallback(err) {
    const status = Number(err?.status ?? err?.response?.status ?? 0);
    return status === 404 || status === 405 || status === 501;
}

async function requestFirstAvailable(paths = [], options = {}) {
    let lastErr = null;
    for (const path of paths) {
        try {
            return await request(path, options);
        } catch (err) {
            if (!canFallback(err)) throw err;
            lastErr = err;
        }
    }
    if (lastErr) throw lastErr;
    throw new Error("No endpoint paths configured");
}

export const authApi = {
    login: (email, password, captchaToken) =>
        request("/auth/login", {
            method: "POST",
            json: { email, password, captchaToken: captchaToken || null },
        }),

    register: (fullName, email, password, captchaToken, options = {}) =>
        request("/auth/register", {
            method: "POST",
            json: {
                fullName,
                email,
                password,
                captchaToken: captchaToken || null,
                client: options?.client === false ? false : true,
                psychologistId: Number.isFinite(Number(options?.psychologistId)) ? Number(options.psychologistId) : null,
                source: options?.source ? String(options.source) : null,
                acceptPolicy: options?.acceptPolicy === true,
                acceptAge: options?.acceptAge === true,
                marketing: options?.marketing === true,
                legalDocumentVersion: options?.legalDocumentVersion ? String(options.legalDocumentVersion) : null,
                sourcePage: options?.sourcePage ? String(options.sourcePage) : null,
            },
        }),

    registerVerify: (email, code) =>
        request("/auth/register/verify", { method: "POST", json: { email, code } }),

    registerResend: (email, captchaToken) =>
        request("/auth/register/resend", { method: "POST", json: { email, captchaToken: captchaToken || null } }),

    recoveryRequest: (email, captchaToken) =>
        request("/auth/recovery/request", { method: "POST", json: { email, captchaToken: captchaToken || null } }),

    recoveryVerify: (email, code) =>
        request("/auth/recovery/verify", { method: "POST", json: { email, code } }),

    recoveryConfirm: (email, code, newPassword) =>
        request("/auth/recovery/confirm", { method: "POST", json: { email, code, newPassword } }),

    loginByClientLink: (token) =>
        requestFirstAvailable(
            [
                "/auth/client-link/login",
                "/auth/direct-link/login",
                "/auth/magic/login",
            ],
            {
                method: "POST",
                json: { token: String(token || "").trim() },
            }
        ),

    completeClientLinkProfile: ({ token, email, password, confirmPassword, skip = false } = {}) =>
        requestFirstAvailable(
            [
                "/auth/client-link/complete-profile",
                "/auth/direct-link/complete-profile",
                "/auth/magic/complete-profile",
            ],
            {
                method: "POST",
                json: {
                    token: String(token || "").trim() || null,
                    email: String(email || "").trim() || null,
                    password: String(password || ""),
                    confirmPassword: String(confirmPassword || ""),
                    skip: skip === true,
                },
            }
        ),

    refresh: () => request("/auth/refresh", { method: "POST", json: {} }),
    logout: () => request("/auth/logout", { method: "POST", json: {} }),
    me: () => request("/api/me", { method: "GET" }),
};
